import { fromEvent, startWith, map, distinctUntilChanged, switchMap } from 'rxjs';

import { parseDateApi } from './date.js';
import { createWeekPlanView } from './week-plan-view.js';
import { createAddDishView } from './add-dish-view.js';
import { createEditDishView } from './edit-dish-view.js';
import { createDishesView } from './dishes-view.js';

let routePath$ = fromEvent(window, 'hashchange').pipe(
    startWith(undefined),
    map(() => {
        let hash = window.location.hash || '';
        if (hash.startsWith('#')) {
            hash = hash.substring(1);
        }
        return hash.trim();
    }),
    distinctUntilChanged()
);

let view$ = routePath$.pipe(
    map((path) => {
        if (path === '') {
            return createWeekPlanView(new Date());
        } else if (path.startsWith('/plan/')) {
            let dateStr = path.substring('/plan/'.length);
            return createWeekPlanView(parseDateApi(dateStr));
        } else if (path.startsWith('/add-dish/')) {
            let dateStr = path.substring('/add-dish/'.length);
            return createAddDishView(parseDateApi(dateStr));
        } else if (path === '/create-dish') {
            return createEditDishView();
        } else if (path.startsWith('/edit-dish/')) {
            let dishId = parseInt(path.substring('/edit-dish/'.length));
            return createEditDishView(dishId);
        } else if (path === '/dishes') {
            return createDishesView();
        } else {
            console.warn(`Unknown route: ${path}`);
            return createWeekPlanView(new Date());
        }
    })
);

view$.pipe(switchMap((view$) => view$)).subscribe({
    error: (err) => console.error('Unhandled error in view stream:', err),
});
